import React, { memo } from 'react'
import Image from 'next/image'
import Link from 'next/link'

interface Props {
  imageUrl: string
  title: string
  description: string
  link: string
  isImage?: boolean
}

const TabCard: React.FC<Props> = ({ imageUrl, title, description, link, isImage = true }) => {
  return (
    <article className="flex items-start gap-4">
      {/* Hình ảnh */}
      {isImage && (
        <div className="flex-shrink-0 w-40 h-24 relative">
          <Link href={`/${link}`}>
            <Image
              src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
              alt={title}
              title={title}
              width={160}
              height={96}
              className="w-full h-full object-cover"
              priority
              unoptimized
            />
          </Link>
        </div>
      )}

      {/* Nội dung */}
      <div className="flex-1">
        {/* Tiêu đề */}
        <Link href={`/${link}`} title={title}>
          <h3 className="text-lg font-title font-semibold text-gray-800 hover:text-primary transition">
            {title}
          </h3>
        </Link>

        {/* Mô tả */}
        <p className="text-sm text-gray-600 mt-1 line-clamp-4">{description}</p>
      </div>
    </article>
  )
}

export default memo(TabCard)
